import { simperService } from "@/apis/services"
import { IPaginationMeta, IPaginationParamV2, ISimper, ISimperQr } from "@/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface ISimperState {
  simpers: ISimper[]
  currentSimper: ISimper | null
  simperQr: ISimperQr | null
  meta?: IPaginationMeta
  isLoading: boolean
  error: string | null
  fetchSimperRecords: (params: IPaginationParamV2) => Promise<void>
  fetchSimperRecordBySimperNumber: (simperNumber: string) => Promise<void>
  fetchSimperQrBySimperNumber: (simperNumber: string) => Promise<void>
}

const initialState = {
  simpers: [],
  currentSimper: null,
  simperQr: null,
  meta: undefined,
  isLoading: false,
  error: null,
}

export const useSimperStore = create<ISimperState>()(
  devtools((set) => ({
    ...initialState,

    fetchSimperRecords: async (params: IPaginationParamV2): Promise<void> => {
      set({ isLoading: true, error: null })
      try {
        const response = await simperService.getSimperRecords(params)
        set({ simpers: response.data.items, meta: response.data.meta })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occured"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },

    fetchSimperRecordBySimperNumber: async (simperNumber: string): Promise<void> => {
      set({ isLoading: true, error: null })
      try {
        const response = await simperService.getSimperBySimperNumber(simperNumber)
        set({ currentSimper: response.data })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occured"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },

    fetchSimperQrBySimperNumber: async (simperNumber: string): Promise<void> => {
      set({ isLoading: true, error: null })
      try {
        const response = await simperService.getSimperQrBySimperNumber(simperNumber)
        set({ simperQr: response.data })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occured"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },
  }))
)
